<template>
    <div class="filters-wrapper">
        <div class="filters-nav-mobile" v-if="windowWidth < 678">
            <span class="btn btn-filter-on" @click="toggleFilters()">filter on <span class="caret"></span></span>
            <a href="/favorites" class="btn btn-orange btn-favorites">My favorites <span v-if="noofFavorites">({{noofFavorites}})</span></a>
        </div>
        <div class="filters" v-on-clickaway="closeAllFilters">
            <div v-if="filters[0]" :class="{'open': filterOpen[0], 'filter' : true, 'gender' : true}">
                <div class="btn-filter" @click="toggleFilter(0)">
                    {{ filters[0].label }}
                    <span class="remove-filter" v-if="filters[0].label !== filterLabelsDefault[0]" @click.stop="removeFilter(0)">x</span>
                </div>
                <ul v-if="filterOpen[0]" class="choices">
                    <li class="choice" @click="setFilter(0,0,'Man')">{{ trans('filters.Man') }}</li>
                    <li class="choice" @click="setFilter(0,0,'Vrouw')">{{ trans('filters.Vrouw') }}</li>
                </ul>
            </div>
            <div v-if="filters[1]" :class="{'open': filterOpen[1], 'filter' : true, 'age' : true}">
                <div class="btn-filter" @click="toggleFilter(1)">
                    {{ filters[1].label }}
                    <span class="remove-filter" v-if="filters[1].label !== filterLabelsDefault[1]"
                          @click.stop="resetAge()">x</span>
                </div>
                <ul v-if="filterOpen[1]" class="choices choices-age" @blur="closeFilter(1)">
                    <li class="choice"><input type="number" :placeholder="trans('filters.van')" v-model="ageMin" @keyup="setAgeMin()" @blur="closeAge()" min="0" max="150"></li>
                    <li class="choice"><input type="number" :placeholder="trans('filters.tot')" v-model="ageMax" @keyup="setAgeMax()" @blur="closeAge()" min="0" max="150"></li>
                </ul>
            </div>
            <div v-if="filters[2]" :class="{'open': filterOpen[2], 'filter' : true, 'looks' : true}">
                <div class="btn-filter" @click="toggleFilter(2)">
                    {{ filters[2].label }}
                    <span class="remove-filter" v-if="filters[2].label !== filterLabelsDefault[2]"
                          @click.stop="removeFilter(2)">x</span>
                </div>
                <ul v-if="filterOpen[2]" class="choices">
                    <li class="choice" @click="setFilter(2,3,'Europees')">{{ trans('filters.Europees') }}</li>
                    <li class="choice" @click="setFilter(2,3,'Zuid-Europees')">{{ trans('filters.Zuid-Europees') }}</li>
                    <li class="choice" @click="setFilter(2,3,'Oost-Europees')">{{ trans('filters.Oost-Europees') }}</li>
                    <li class="choice" @click="setFilter(2,3,'Surinaams')">{{ trans('filters.Surinaams') }}</li>
                    <li class="choice" @click="setFilter(2,3,'Arabisch')">{{ trans('filters.Arabisch') }}</li>
                    <li class="choice" @click="setFilter(2,3,'Antilliaans')">{{ trans('filters.Antilliaans') }}</li>
                    <li class="choice" @click="setFilter(2,3,'Afrikaans')">{{ trans('filters.Afrikaans') }}</li>
                    <li class="choice" @click="setFilter(2,3,'Aziatisch')">{{ trans('filters.Aziatisch') }}</li>
                    <li class="choice" @click="setFilter(2,3,'Indiaas')">{{ trans('filters.Indiaas') }}</li>
                    <li class="choice" @click="setFilter(2,3,'Latino')">{{ trans('filters.Latino') }}</li>
                </ul>
            </div>
            <div v-if="filters[3]" :class="{'open': filterOpen[3], 'filter' : true, 'category' : true}">
                <div class="btn-filter" @click="toggleFilter(3)">
                    {{ filters[3].label }}
                    <span class="remove-filter" v-if="filters[3].label !== filterLabelsDefault[3]"
                          @click.stop="removeFilter(3)">x</span>
                </div>
                <ul v-if="filterOpen[3]" class="choices">
                    <li class="choice" @click="setFilter(3,4,'PEOPLE')">{{ trans('filters.SPECIAL') }}</li>
                    <li class="choice" @click="setFilter(3,4,'PEOPLE.PLUS', 'PEOPLE PLUS')">{{trans('filters.PEOPLE-PLUS') }}
                    </li>
                    <li class="choice" @click="setFilter(3,4,'SPEC.PLUS', 'MODELS')">{{ trans('filters.SPEC-PLUS') }}
                    </li>
                    <li class="choice seperator" @click="setFilter(3,4,'Acteur')">{{ trans('filters.Acteur') }}</li>
                    <li class="choice" @click="setFilter(3,5,'Hostessen')">{{ trans('filters.Hostessen') }}</li>
                    <li class="choice" @click="setFilter(3,5,'Families')">{{ trans('filters.Families') }}</li>
					<li class="choice" @click="setFilter(3,5,'Handmodellen')">{{ trans('filters.Handmodellen') }}</li>
					<li class="choice" @click="setFilter(3,5,'Haarmodellen')">{{ trans('filters.Haarmodellen') }}</li>
                    <li class="choice" @click="setFilter(3,5,'Sportmodellen')">{{ trans('filters.Sportmodellen') }}</li>
                    <li class="choice" @click="setFilter(3,5,'Lingerie')">{{ trans('filters.Lingerie') }}</li>
                </ul>
            </div>
            <div v-if="filters[4]" :class="{'open': filterOpen[4], 'filter' : true, 'haircolor' : true}">
                <div class="btn-filter" @click="toggleFilter(4)">
                    {{ filters[4].label }}
                    <span class="remove-filter" v-if="filters[4].label !== filterLabelsDefault[4]"
                          @click.stop="removeFilter(4)">x</span>
                </div>
                <ul v-if="filterOpen[4]" class="choices">
                    <li v-for="color in hairColors" :key="color" class="choice" @click="setFilter(4,6, color, trans('filters.'+color) )">{{
                        trans('filters.'+color) }}
                    </li>
                </ul>
            </div>
            <div class="filter input">
                <input type="text" v-model="idOrName" :placeholder="trans('talents.home.search')" @keyup="setIdOrName">
            </div>
        </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    import {mixin as clickaway} from 'vue-clickaway';

    export default {
        mixins: [clickaway],
        components: {},
        data: function () {
            return {
                filterLabelsDefault: [this.trans('filters.Geslacht'), this.trans('filters.Leeftijd'), this.trans('filters.Look'), this.trans('filters.Categorie'), this.trans('filters.Haarkleur')],
                filterKeys: ['Geslacht', 'Leeftijd_van', 'Leeftijd_tot', 'Look', 'Klasse', 'Specialiteit', 'Haarkleur'],
                filters: [],
                filterOpen: [],
                hairColors: ["blond", "l_blond", "d_blond", "blond-grijs", "bruin", "l_bruin", "d_bruin", "bruin-grijs", "rood", "rood-blond", "rood-bruin", "rood-grijs", "grijs", "zwart", "zwart-grijs"],
                ageMin: '',
                ageMax: '',
                idOrName: '',
                timer: false
            }
        },
        created() {
            _.each(this.filterLabelsDefault, function (value, key) {
                Vue.set(this.filters, key, {'label': value})
            }.bind(this))
        },
        computed: {
            ...mapState(['favorites']),
            noofFavorites() {
                return this.favorites[this.project] ? this.favorites[this.project].length : false
            },
        },
        watch: {},
        methods: {
            updateFilters() {
                this.$store.dispatch('setFilters', this.filters)
                this.$parent.$emit('reloadModels')
            },
            setFilter(index, keyIndex, label, btnLabel) {
                if (btnLabel === undefined) {
                    btnLabel = label
                }
                Vue.set(this.filters, index, {'label': btnLabel, 'key': this.filterKeys[keyIndex], 'value': label})
                this.updateFilters()
                this.$store.dispatch('forceHidePreview')
                this.closeFilter(index)
            },
            removeFilter(index) {
                Vue.set(this.filters, index, {'label': this.filterLabelsDefault[index]})
                this.updateFilters()
                this.closeFilter(index)
            },
            toggleFilter(index) {
                Vue.set(this.filterOpen, index, !this.filterOpen[index])
                this.closeOtherFilters(index)
            },
            openFilter(index) {
                Vue.set(this.filterOpen, index, true)
            },
            closeOtherFilters(exclude) {
                for (let i = 0; i < 6; i++) {
                    if (exclude !== i) {
                        this.closeFilter(i)
                    }
                }
            },
            closeAllFilters() {
                for (let i = 0; i < 6; i++) {
                    this.closeFilter(i)
                }
            },
            closeFilter(index) {
                Vue.set(this.filterOpen, index, false)
            },
            setAgeMin() {
                this.setAgeLabel()
                Vue.set(this.filters, 6, {'label': this.ageMin, 'key': 'Leeftijd_van', 'value': this.ageMin})
            },
            setAgeMax() {
                this.setAgeLabel()
                Vue.set(this.filters, 7, {'label': this.ageMax, 'key': 'Leeftijd_tot', 'value': this.ageMax})
            },
            closeAge() {
                this.timer = setTimeout(function () {
                    this.closeFilter(1)
                }.bind(this), 1200);
            },
            setAgeLabel() {
                clearTimeout(this.timer)
                let label = this.ageMin + '-' + this.ageMax
                Vue.set(this.filters, 1, {'label': label})
                this.timer = setTimeout(function () {
                    this.updateFilters()
                }.bind(this), 1200)
            },
            resetAge() {
                this.ageMin = ''
                this.ageMax = ''
                Vue.set(this.filters, 6, {})
                Vue.set(this.filters, 7, {})
                this.removeFilter(1)
            },
            setIdOrName() {
                let label = this.idOrName
                Vue.set(this.filters, 5, {'label': label, 'key': 'q', 'value': label})
                clearTimeout(this.timer)
                this.timer = setTimeout(function () {
                    this.updateFilters()
                }.bind(this), 800)
            },
            toggleFilters() {
                if (document.body.classList.contains('filters-open')) {
                    document.body.classList.remove('filters-open')
                } else {
                    document.body.classList.add('filters-open')
                }
            }
        },
    };
</script>
